// extracted by mini-css-extract-plugin
module.exports = {"panelWrapper":"tabModuleMobile_panelWrapper__JaYFL","tabsContent":"tabModuleMobile_tabsContent__OxVor","swiperSlideItem":"tabModuleMobile_swiperSlideItem__HzVmw"};